import ReportTable from './report-table'

const builtReportTables = []

document.addEventListener('turbolinks:load', function () {
  document
    .querySelectorAll("[data-behaviour='report-table']")
    .forEach(function (el) {
      builtReportTables.push(new ReportTable(el))
    })
})

document.addEventListener('turbolinks:before-visit', function () {
  builtReportTables.forEach((reportTable) => {
    reportTable.teardown()
  })

  builtReportTables.length = 0
})
